import React from 'react';
import './Pgraph.css';

const Pgraph = ({ children }) => {
  return <p className="pgraph">{children}</p>;
};

export default Pgraph;
